// extracted by mini-css-extract-plugin
export var chip = "_qk-2";
export var chipBody = "_qk-8";
export var chipHeader = "_qk-9";
export var chipWithKind = "_qk-7";
export var icon = "_qk-3";
export var kind = "_qk-a";
export var remove = "_qk-5";
export var removeIcon = "_qk-6";
export var row = "_qk-0";
export var rowHistorical = "_qk-1";
export var text = "_qk-4";